import IDEE from 'utils/Mapea';
import Utils from 'utils/Utils';
import LocalStorage from 'utils/LocalStorage';

import MAPA from 'static/img/mapa.png';
import IMAGEN from 'static/img/image.png';
import RASTER from 'static/img/raster.png';
import HIBRIDO from 'static/img/hibrido.png';
import HISTORICOS from 'static/img/historicos.png';
import LIDAR from 'static/img/lidar.png';
import OCUPACION from 'static/img/ocupacion_suelo.png';
import IberpixES from 'static/img/iberpix_es.png';

declare var ol;
declare var PRECHARGED;
declare var CONFIGURATIONS;
declare var HELP_DATA_PLUGIN_ES;
declare var HELP_DATA_PLUGIN_EN;

export let mapjs;

export const initMap = (unblock, t, params) => {
  const defaultSRS = 'EPSG:3857';
  const lang = LocalStorage.getString('language') || 'es';
  IDEE.config.MOVE_MAP_EXTRACT = false;
  const helpUrl = 'https://www.ign.es/iberpix/help?node=CodigosEPSG';
  IDEE.language.setLang(lang);
  let zoom = IDEE.config.MAP_VIEWER_ZOOM || 5;
  let center = IDEE.config.MAP_VIEWER_CENTER || [-428106.86611520057, 4334472.25393817];
  let mouseProjection = IDEE.config.MAP_VIEWER_SRS || defaultSRS;
  let mouseProjectionLabel = mouseProjection;
  if (IDEE.config.MAP_VIEWER_SRS && IDEE.config.MAP_VIEWER_CENTER) {
    try {
      center = ol.proj.transform(center, mouseProjection, defaultSRS);
    } catch (e) {
      console.warn(e);
      mouseProjectionLabel = 'EPSG:4326';
    }
  }

  let layers = IDEE.config.MAP_VIEWER_LAYERS || [];

  // Parámetros GET adicionales
  var getParams = new URLSearchParams(window.location.search); 

  var helpPosition = parseFloat(getParams.get("helpPosition"));
  if(helpPosition){
    console.log("helpPosition ", helpPosition);
    waitForElement();

    function waitForElement() {
      const checkMapjsInterval = setInterval(() => {
        if (typeof mapjs !== "undefined" && mapjs.getPlugins("help").length > 0) {
          mapjs.getPlugins("help")[0].ctrl.showHelp(helpPosition);
          clearInterval(checkMapjsInterval); // Detener el intervalo una vez que se encontró el elemento
        }
      }, 250)
    }
  }




  if (Utils.isMobile()) {
    mapjs = IDEE.map({
      container: 'map',
      controls: ['location', 'rotate*0'],
      center: center,
      zoom: zoom !== 5 ? zoom : (zoom - 1),
      minZoom: 3,
      maxZoom: 20,
    });

    if (layers.length !== 0) {
      mapjs.addLayers(layers);
    }

    window.mapjs = mapjs;
    mapjs.addPlugin(new IDEE.plugin.BackImgLayer(getConfiguredBaseLayersPlugin(t)));
    mapjs.addPlugin(new IDEE.plugin.MeasureBar({ position: 'BR', order: 17 }));


    // const mp_IGNSearchLocator = new IDEE.plugin.IGNSearchLocator({
    //   servicesToSearch: 'gn',
    //   searchPosition: 'geocoder,nomenclator',
    //   maxResults: 10,
    //   isCollapsed: false,
    //   position: 'TL',
    //   reverse: true,
    //   order: 10,
    //   nomenclatorSearchType: IGNSEARCH_TYPES_CONFIGURATION,
    //   noProcess: "-",
    //   helpUrl: helpUrl,
    // });
    // mp_IGNSearchLocator.nomenclatorSearchType = IGNSEARCH_TYPES_CONFIGURATION
    // mapjs.addPlugin(mp_IGNSearchLocator);
    // window.mp_IGNSearchLocator = mp_IGNSearchLocator;

    const mp_Locator = new IDEE.plugin.Locator({
      position: 'TC',
      useProxy: false,
      collapsible: true,
      collapsed: true,
      zoom: 16,
      pointStyle: 'pinAzul',
      byParcelCadastre: true,
      byCoordinates: true,
      byPlaceAddressPostal: {
        servicesToSearch: 'g',
        maxResults: 33,
        noProcess: 'expendeduria',
        reverse: false,
        searchPosition: 'geocoder',
      },
      isDraggable: false,
    });
    
    mapjs.addPlugin(mp_Locator);


    mapjs.getMapImpl().once('postrender', (evt) => {
      // mp_IGNSearchLocator.nomenclatorSearchType = IGNSEARCH_TYPES_CONFIGURATION
      let ayudaBoton = document.getElementById("ayudaBoton")
      ayudaBoton.style.display = "None"
      unblock();
    });
  } else {
    mapjs = IDEE.map({
      container: 'map',
      controls: ['scale*true*18'],
      center: center,
      zoom: zoom,
      minZoom: 0,
      maxZoom: 20,
    });

    if (layers.length !== 0) {
      mapjs.addLayers(layers);
    }

    window.mapjs = mapjs;
    mapjs.addPlugin(new IDEE.plugin.BackImgLayer(getConfiguredBaseLayersPlugin(t)));
    mapjs.addPlugin(new IDEE.plugin.SelectionZoom(getConfiguredZoomSelectionPlugin(t)));

    // mapjs.addPlugin(new IDEE.plugin.Vectors(getConfiguredVectorsPlugin()));

    mapjs.addPlugin(

      new IDEE.plugin.VectorsManagement({
        order:14,
        position: 'TR',
        collapsible: true,
        collapsed: true,
        selection: true,
        addlayer: true,
        creation: true,
        edition: true,
        style: true,
        analysis: true,
        download: true,
        help: true,
    })

    );

    

    mapjs.addPlugin(new IDEE.plugin.Information({ position: 'TR', order: 18 }));
    mapjs.addPlugin(new IDEE.plugin.MeasureBar({ position: 'TR', order: 17 }));
    mapjs.addPlugin(new IDEE.plugin.Attributions({ mode: 1, scale: 10000, order: 9 }));
    // mapjs.addPlugin(new IDEE.plugin.Georefimage2({ position: 'TR', order: 15 }));

    // mapjs.addPlugin(new IDEE.plugin.ZoomPanel({ position: 'TL', collapsed: true, order: 3 }));
    const mpZoomPanel = new IDEE.plugin.ViewManagement({
      position: 'TL',
      collapsible: true,
      collapsed: true,
      zoomExtent: true,
      viewhistory: true,
      zoompanel: true,
      isDraggable: false,
    });
    mapjs.addPlugin(mpZoomPanel);

    const mpINCICARTO = new IDEE.plugin.Incicarto({
      order: 1,
      collapsed: true,
      collapsible: true,
      position: 'TR',
      interfazmode: 'simple', //simple, advance, both
      buzones: [{
          name: 'Cartografía (MTN, BTN, RT, HY, Pob, BCN, Prvinciales, escalas pequeñas)',
          email: 'cartografia.ign@mitma.es',
        },
        {
          name: 'Atlas Nacional de España',
          email: 'ane@mitma.es',
        },
      ],
      controllist: [{
          id: 'themeList',
          name: 'Temas de errores',
          mandatory: true,
        },
        {
          id: 'errorList',
          name: 'Tipos de errores',
          mandatory: true,
        },
        {
          id: 'productList',
          name: 'Lista de productos',
          mandatory: true,
        }
      ],
      themeList: [{
          idTheme: "1",
          nameTheme: 'Sin especificar',
          emailTheme: 'consulta@cnig.es',
        },
        {
          idTheme: "2",
          nameTheme: 'Cartografía',
          emailTheme: 'cartografia.ign@mitma.es',
        },
        {
          idTheme: "3",
          nameTheme: 'Documentación histórica',
          emailTheme: 'documentacionign@mitma.es',
        },
        {
          idTheme: "4",
          nameTheme: 'Líneas Límite Municipales',
          emailTheme: 'limites_municipales@mitma.es',
        },
        {
          idTheme: "5",
          nameTheme: 'Nombres geográficos',
          emailTheme: 'toponimia.ign@mitma.es',
        },
        {
          idTheme: "6",
          nameTheme: 'Callejero y Redes de Transporte',
          emailTheme: 'cartografia.ign@mitma.es',
        }

      ],
      errorList: [
        'No especificado',
        'Omisión',
        'Comisión',
        '...',
      ],
      productList: [
        'No especificado',
        'Serie MTN25',
        'Serie MTN50',
        '...',
      ],
    });
    mapjs.addPlugin(mpINCICARTO);
    mpINCICARTO.panel_._element.style.order = 14
    //window.mpINCICARTO = mpINCICARTO

    // mapjs.addPlugin(new IDEE.plugin.FullTOC({
    //   collapsed: true,
    //   position: 'TR',
    //   https: true,
    //   http: true,
    //   precharged: PRECHARGED,
    //   order: 12,
    // }));

    mapjs.addPlugin(
      new IDEE.plugin.Layerswitcher({
      collapsed: true,
      position: 'TR',
      https: true,
      http: true,
      isDraggable: false,
      modeSelectLayers: 'eyes',
      tools: ['transparency', 'legend', 'zoom', 'information', 'style', 'delete'],
      isMoveLayers: true,
      https: true,
      http: true,
      showCatalog: true,
      precharged: PRECHARGED,
      order: 12,
    }));

    // mapjs.addPlugin(new IDEE.plugin.PrinterMap({
    //   position: 'TR',
    //   collapsed: true,
    //   georefActive: false,
    //   order: 14,
    //   logo: window.location.href.split('/iberpix/')[0] + IberpixES,
    // }));

    // mapjs.addPlugin(new IDEE.plugin.Georefimage2({ position: 'TR', order: 15 }));

    mapjs.addPlugin(
        new IDEE.plugin.PrintViewManagement({
          order: 15,
          isDraggable: false,
          position: 'TR',
          collapsible: true,
          collapsed: true,
          tooltip: 'Imprimir',
          serverUrl: 'https://componentes.cnig.es/geoprint',
          printStatusUrl: 'https://componentes.cnig.es/geoprint/print/status',
          defaultOpenControl: 1,
          georefImageEpsg: {
            tooltip: 'Georeferenciar imagen',
            layers: [
              {
                url: 'http://www.ign.es/wms-inspire/mapa-raster?',
                name: 'mtn_rasterizado',
                format: 'image/jpeg',
                legend: 'Mapa ETRS89 (long,lat)  (EPSG:4326)',
                EPSG: 'EPSG:4326',
              },
              {
                url: 'http://www.ign.es/wms-inspire/mapa-raster?',
                name: 'mtn_rasterizado',
                format: 'image/jpeg',
                legend: 'Mapa WGS84/Pseudo-Mercator (EPSG:3857)',
                EPSG: 'EPSG:3857',
              },
              {
                url: 'http://www.ign.es/wms-inspire/mapa-raster?',
                name: 'mtn_rasterizado',
                format: 'image/jpeg',
                legend: 'Mapa ETRS89/UTM-31-N (EPSG:25831)',
                EPSG: 'EPSG:25831',
              },
              {
                url: 'http://www.ign.es/wms-inspire/mapa-raster?',
                name: 'mtn_rasterizado',
                format: 'image/jpeg',
                legend: 'Mapa ETRS89/UTM-30-N (EPSG:25830)',
                EPSG: 'EPSG:25830',
              },
              {
                url: 'http://www.ign.es/wms-inspire/mapa-raster?',
                name: 'mtn_rasterizado',
                format: 'image/jpeg',
                legend: 'Mapa ETRS89/UTM-29-N (EPSG:25829)',
                EPSG: 'EPSG:25829',
              },
              {
                url: 'http://www.ign.es/wms-inspire/mapa-raster?',
                name: 'mtn_rasterizado',
                format: 'image/jpeg',
                legend: 'Mapa ETRS89/UTM-28-N (EPSG:25828)',
                EPSG: 'EPSG:25828',
              },
              {
                url: 'http://www.ign.es/wms-inspire/pnoa-ma?',
                name: 'OI.OrthoimageCoverage',
                format: 'image/jpeg',
                legend: 'Imagen (PNOA) ETRS89 (long,lat) (EPSG:4326)',
                EPSG: 'EPSG:4326',
              },
              {
                url: 'http://www.ign.es/wms-inspire/pnoa-ma?',
                name: 'OI.OrthoimageCoverage',
                format: 'image/jpeg',
                legend: 'Imagen (PNOA) WGS84/Pseudo-Mercator (EPSG:3857)',
                EPSG: 'EPSG:3857',
              },
              {
                url: 'http://www.ign.es/wms-inspire/pnoa-ma?',
                name: 'OI.OrthoimageCoverage',
                format: 'image/jpeg',
                legend: 'Imagen (PNOA) ETRS89/UTM-31-N (EPSG:25831)',
                EPSG: 'EPSG:25831',
              },
              {
                url: 'http://www.ign.es/wms-inspire/pnoa-ma?',
                name: 'OI.OrthoimageCoverage',
                format: 'image/jpeg',
                legend: 'Imagen (PNOA) ETRS89/UTM-30-N (EPSG:25830)',
                EPSG: 'EPSG:25830',
              },
              {
                url: 'http://www.ign.es/wms-inspire/pnoa-ma?',
                name: 'OI.OrthoimageCoverage',
                format: 'image/jpeg',
                legend: 'Imagen (PNOA) ETRS89/UTM-29-N (EPSG:25829)',
                EPSG: 'EPSG:25829',
              },
              {
                url: 'http://www.ign.es/wms-inspire/pnoa-ma?',
                name: 'OI.OrthoimageCoverage',
                format: 'image/jpeg',
                legend: 'Imagen (PNOA) ETRS89/UTM-28-N (EPSG:25828)',
                EPSG: 'EPSG:25828',
              },
            ],
          },
          georefImage: {
            tooltip: 'Georeferenciar imagen',
            printTemplateUrl: 'https://componentes.cnig.es/geoprint/print/mapexport',
            printSelector: false,
            printType: 'client', // 'client' or 'server'
          },
          printermap: {
            printTemplateUrl: 'https://componentes.cnig.es/geoprint/print/CNIG',
            // fixedDescription: true,
            filterTemplates: [
              'A3 Horizontal', 'A3 Horizontal (con leyenda)', 'A3 Vertical (con leyenda)', 'A4 Horizontal', 'A4 Horizontal (con leyenda)', 
              'A4 Vertical', 'A4 Vertical (con leyenda)', 'A3 Horizontal (Perfil Topográfico)', 'A3 Horizontal (Perfil Topográfico) (con leyenda)', 
              'A3 Vertical (Perfil Topográfico)', 'A3 Vertical (Perfil Topográfico) (con leyenda)', 'A4 Horizontal (Perfil Topográfico)', 
              'A4 Horizontal (Perfil Topográfico) (con leyenda)', 'A4 Vertical (Perfil Topográfico)', 'A4 Vertical (Perfil Topográfico) (con leyenda)'
            ],
            logo: window.location.href.split('/iberpix/')[0] + IberpixES,
          },
        })
    );

    // mapjs.addPlugin(new IDEE.plugin.Modal({
    //   position: 'BL',
    //   collapsed: true,
    //   url_es: CONFIGURATIONS.url_help_es,
    //   url_en: CONFIGURATIONS.url_help_en,
    //   order: 5,
    // }));

    mapjs.addPlugin(new IDEE.plugin.ContactLink({
      position: 'BL',
      descargascnig: CONFIGURATIONS.descargascnig,
      pnoa: CONFIGURATIONS.pnoa,
      visualizador3d: CONFIGURATIONS.visualizador3d,
      fototeca: CONFIGURATIONS.fototeca,
      twitter: CONFIGURATIONS.twitter,
      instagram: CONFIGURATIONS.instagram,
      facebook: CONFIGURATIONS.facebook,
      pinterest: CONFIGURATIONS.pinterest,
      youtube: CONFIGURATIONS.youtube,
      mail: 'mailto:' + CONFIGURATIONS.mail,
      order: 6,
    }));

    mapjs.addPlugin(

      new IDEE.plugin.Comparators({
        position: 'TL',
        enabledDisplayInLayerSwitcher: true,
        collapsed: true,
        collapsible: true,
        defaultCompareMode: 'none', // mirrorpanelParams - lyrcompareParams - transparecyParams - none
        order: 4,
        listLayers: [

        ],
        enabledKeyFunctions: true,

        transparencyParams: {
          radius: 100,
          maxRadius: 200,
          minRadius: 10,
        },

        lyrcompareParams: {
          staticDivision: 2,
          defaultLyrA: 0,
          defaultLyrB: 1,
          defaultLyrC: 2,
          defaultLyrD: 3,
          opacityVal: 100,
          defaultCompareViz: 1,
        },

        mirrorpanelParams: {
          showCursors: true,
          principalMap: true,
          enabledControlsPlugins: {
            map2: {
              BackImgLayer: getConfiguredBaseLayersPlugin(t),
              Layerswitcher: {
                collapsed: true,
                position: 'TR',
                https: true,
                http: true,
                isDraggable: false,
                modeSelectLayers: 'eyes',
                tools: ['transparency', 'legend', 'zoom', 'information', 'style', 'delete'],
                isMoveLayers: true,
                https: true,
                http: true,
                showCatalog: true,
                precharged: PRECHARGED,
                order: 12,
              },
              
            },
            map3: {
              controls: ['scale'],
            },
            map4: {

            },
          },
          defaultCompareViz: 2,
          modeVizTypes: [0, 1, 2, 3, 5], // 0 - 9
        },

        windowsyncParams:{

          controls: ['scale'],

          plugins: [
            {
              name: 'Layerswitcher',
              params: {
                collapsed: true,
                position: 'TR',
                https: true,
                http: true,
                isDraggable: false,
                modeSelectLayers: 'eyes',
                tools: ['transparency', 'legend', 'zoom', 'information', 'style', 'delete'],
                isMoveLayers: true,
                https: true,
                http: true,
                showCatalog: true,
                precharged: PRECHARGED,
                order: 11,
              },
            },
            {
              name: 'BackImgLayer',
              params: getConfiguredBaseLayersPlugin(t),
              // params: getConfiguredBaseLayersPlugin_stringLayers(t),

            },
            {
              name: 'Information',
              params:{ 
                position: 'TR', 
                order: 18 
              }
            }
          ],
        }
      })

    );

    mapjs.addPlugin(new IDEE.plugin.OverviewMap({
      position: 'BL',
      fixed: true,
      zoom: 4,
      baseLayer: 'WMTS*https://www.ign.es/wmts/mapa-raster?*MTN*GoogleMapsCompatible*Cartografía del IGN*false*image/png*false*false*true',
      collapsed: true,
      collapsible: true,
      order: 8,
    }));


    mapjs.addPlugin(new IDEE.plugin.MouseSRS({
      position: 'BL',
      tooltip: t('visor.coordinates'),
      srs: mouseProjection,
      label: mouseProjectionLabel,
      precision: 4,
      geoDecimalDigits: 6,
      utmDecimalDigits: 2,
      activeZ: true,
      helpUrl: helpUrl,
      order: 11,
    }));

    mapjs.addPlugin(new IDEE.plugin.ShareMap({
      baseUrl: CONFIGURATIONS.api_url + '/',
      position: 'BL',
      title: t('visor.share_url'),
      tooltip: t('visor.copied'),
      btn: t('visor.accept'),
      copyBtn: t('visor.copy'),
      minimize: true,
      urlAPI: false,
      order: 7,
      shareLayer: true,
    }));

    mapjs.addPlugin(new IDEE.plugin.Infocoordinates({
      position: 'TR',
      decimalGEOcoord: 6,
      decimalUTMcoord: 2,
      helpUrl: helpUrl,
      order: 16,
    }));


    const mp_Locator = new IDEE.plugin.Locator({
      position: 'TC',
      useProxy: false,
      collapsible: true,
      collapsed: true,
      zoom: 16,
      pointStyle: 'pinAzul',
      byParcelCadastre: true,
      byCoordinates: {
        help: 'https://epsg.io/'
      },
      byPlaceAddressPostal: {
        servicesToSearch: 'g',
        maxResults: 33,
        noProcess: 'expendeduria',
        reverse: true,
        searchPosition: 'geocoder',
      },
      isDraggable: false,
    });
    
    mapjs.addPlugin(mp_Locator);

    const mp_help = new IDEE.plugin.Help({
      position: 'BL',
      
      header:{
          images: [
            'https://www.ign.es/iberpix/static/media/logo.72e2e78b.png',
          ],
          title: {
            es: 'Ayuda de Iberpix realizada con API-CNIG',
            en: "Iberpix help made with API-CNIG"
          }
      },
      
      extendInitialExtraContents: true,
      
      initialExtraContents: {

              es: HELP_DATA_PLUGIN_ES.initialExtraContents,
              en: HELP_DATA_PLUGIN_EN.initialExtraContents,
    
      },

      finalExtraContents: {
        
          es: HELP_DATA_PLUGIN_ES.finalExtraContents,
          en: HELP_DATA_PLUGIN_EN.finalExtraContents,

      },

    });
    window.mp_help = mp_help
    mapjs.addPlugin(mp_help);




    mapjs.getMapImpl().once('postrender', (evt) => {
      // mp_IGNSearchLocator.nomenclatorSearchType = IGNSEARCH_TYPES_CONFIGURATION
      // mp_IGNSearchLocator.controls_[0].nomenclatorSearchType = IGNSEARCH_TYPES_CONFIGURATION
      
      // let elemZoom= document.querySelector('.m-panel.m-plugin-selectionzoom.opened');
      // elemZoom.style.setProperty('z-index', '1000', 'important');

      let elemLocator= document.querySelector('.m-panel.m-plugin-locator.opened.no-collapsible.m-plugin-locator-tc-withpanel');
      elemLocator.style.setProperty('z-index', '999', 'important');

      let ayudaBoton = document.getElementById("ayudaBoton")
      ayudaBoton.onclick = function(){mp_help.ctrl.showHelp()};

      unblock();
    });
  }


  // document.onload = (event) => {
  //   ayudaBoton = document.getElementById("ayudaBoton")
  //   ayudaBoton.onclick = function(){mp_help.ctrl.showHelp()};
  //   unblock();
  // };


};

export const isLoadedMap = () => mapjs !== undefined;

export const addWMSLayer = (name, legend, url, version, tiled, options) => {
  const args = {
    name: name,
    url: url,
    legend: legend,
    transparent: true,
    tiled: tiled,
    version: version,
  };

  const layer = new IDEE.layer.WMS(args, options);

  layer.options.visibility = options.visibility;
  layer.options.displayInLayerSwitcher = options.displayInLayerSwitcher;
  layer.options.queryable = options.queryable;

  if (options && options.hasOwnProperty('visibility')) {
    layer.setVisible(options.visibility);
  }

  if (options && options.hasOwnProperty('displayInLayerSwitcher')) {
    layer.displayInLayerSwitcher = options.displayInLayerSwitcher;
  }

  if (options && options.hasOwnProperty('zIndex')) {
    layer.setZIndex(options.zIndex);
  }

  mapjs.addLayers(layer);
  return layer.getImpl().getExtent();
};

const getConfiguredBaseLayersPlugin = (t) => {
  if (Utils.isMobile()) {
    return {
      order:50,
      position: 'BR',
      layerId: 0,
      layerVisibility: true,
      collapsed: true,
      collapsible: true,
      columnsNumber: 2,
      empty: false,
      layerOpts: [{
          id: 'raster',
          preview: RASTER,
          title: t('visor.map'),
          layers: [
            new IDEE.layer.WMTS({
              url: 'https://www.ign.es/wmts/mapa-raster?',
              name: 'MTN',
              legend: t('visor.map'),
              matrixSet: 'GoogleMapsCompatible',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              format: 'image/jpeg',
            },{displayInLayerSwitcher: false}),
          ],
        },
        {
          id: 'imagen',
          preview: IMAGEN,
          title: t('visor.image'),
          layers: [
            new IDEE.layer.XYZ({
              url: 'https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg',
              name: 'PNOA-MA',
              legend: t('visor.image'),
              projection: 'EPSG:3857',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              tileGridMaxZoom: 19,
            }),
          ],
        },
        {
          id: 'mapa',
          preview: MAPA,
          title: t('visor.street_map'),
          layers: [
            new IDEE.layer.WMTS({
              url: 'https://www.ign.es/wmts/ign-base?',
              name: 'IGNBaseTodo',
              legend: t('visor.street_map'),
              matrixSet: 'GoogleMapsCompatible',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              format: 'image/jpeg',
            },{displayInLayerSwitcher: false}),
          ],
        },
        {
          id: 'hibrido',
          title: t('visor.hybrid'),
          preview: HIBRIDO,
          layers: [
            new IDEE.layer.XYZ({
              url: 'https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg',
              name: 'PNOA-MA',
              legend: t('visor.image'),
              projection: 'EPSG:3857',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              tileGridMaxZoom: 19,
            }),
            new IDEE.layer.WMTS({
              url: 'https://www.ign.es/wmts/ign-base?',
              name: 'IGNBaseOrto',
              matrixSet: 'GoogleMapsCompatible',
              legend: t('visor.toponyms'),
              transparent: true,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              format: 'image/png',
            },{displayInLayerSwitcher: false})
          ],
        },
      ],
    };
  } else {
    return {
      order: 12,
      position: 'TR',
      layerId: 0,
      layerVisibility: true,
      collapsed: true,
      collapsible: true,
      columnsNumber: 4,
      empty: true,
      layerOpts: [{
          id: 'raster',
          preview: RASTER,
          title: t('visor.map'),
          layers: [
            new IDEE.layer.WMTS({
              url: 'https://www.ign.es/wmts/mapa-raster?',
              name: 'MTN',
              legend: t('visor.map'),
              matrixSet: 'GoogleMapsCompatible',
              transparent: false,
              isBase: true,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              format: 'image/jpeg',
            },{displayInLayerSwitcher: false}),
          ],
        },
        {
          id: 'imagen',
          preview: IMAGEN,
          title: t('visor.image'),
          layers: [
            new IDEE.layer.XYZ({
              url: 'https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg',
              name: 'PNOA-MA',
              legend: t('visor.image'),
              projection: 'EPSG:3857',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              tileGridMaxZoom: 19,
            }),
          ],
        },
        {
          id: 'mapa',
          preview: MAPA,
          title: t('visor.street_map'),
          layers: [
            new IDEE.layer.WMTS({
              url: 'https://www.ign.es/wmts/ign-base?',
              name: 'IGNBaseTodo',
              legend: t('visor.street_map'),
              matrixSet: 'GoogleMapsCompatible',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              format: 'image/jpeg',
            },{displayInLayerSwitcher: false}),
          ],
        },
        {
          id: 'hibrido',
          title: t('visor.hybrid'),
          preview: HIBRIDO,
          layers: [
            new IDEE.layer.XYZ({
              url: 'https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg',
              name: 'PNOA-MA',
              legend: t('visor.image'),
              projection: 'EPSG:3857',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              tileGridMaxZoom: 19,
            }),
            new IDEE.layer.WMTS({
              url: 'https://www.ign.es/wmts/ign-base?',
              name: 'IGNBaseOrto',
              matrixSet: 'GoogleMapsCompatible',
              legend: t('visor.toponyms'),
              transparent: true,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              format: 'image/png',
            },{displayInLayerSwitcher: false}),
          ],
        },
        {
          id: 'lidar',
          preview: LIDAR,
          title: t('visor.lidar'),
          layers: [
            new IDEE.layer.WMTS({
              url: 'https://wmts-mapa-lidar.idee.es/lidar?',
              name: 'EL.GridCoverageDSM',
              legend: t('visor.lidar'),
              matrixSet: 'GoogleMapsCompatible',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              format: 'image/png',
            },{displayInLayerSwitcher: false}),
          ],
        },
        {
          id: 'ocupacion-suelo',
          preview: OCUPACION,
          title: t('visor.corine'),
          layers: [
            new IDEE.layer.WMTS({
              url: 'https://servicios.idee.es/wmts/ocupacion-suelo?',
              name: 'LC.LandCoverSurfaces',
              legend: t('visor.corine'),
              matrixSet: 'GoogleMapsCompatible',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              format: 'image/png',
            },{displayInLayerSwitcher: false}),
          ],
        },
        {
          id: 'historicos',
          preview: HISTORICOS,
          title: t('visor.historic'),
          layers: [
            new IDEE.layer.WMTS({
              url: 'https://www.ign.es/wmts/primera-edicion-mtn?',
              name: 'mtn50-edicion1',
              legend: t('visor.historic'),
              matrixSet: 'GoogleMapsCompatible',
              transparent: false,
              displayInLayerSwitcher: false,
              queryable: false,
              visible: true,
              format: 'image/jpeg',
            },{displayInLayerSwitcher: false}),
          ],
        },
      ],
    };
  }
};

const getConfiguredBaseLayersPlugin_stringLayers = (t) => {
  if (Utils.isMobile()) {
    return {
      order:10,
      position: 'BR',
      layerId: 0,
      layerVisibility: true,
      collapsed: true,
      collapsible: true,
      columnsNumber: 2,
      empty: false,
      layerOpts: [{
          id: 'raster',
          preview: RASTER,
          title: t('visor.map'),
          layers: [
            'WMTS*https://www.ign.es/wmts/mapa-raster*MTN*GoogleMapsCompatible*CartografíadelIGN*false*image/jpeg*false*false*true',
          ],
        },
        {
          id: 'imagen',
          preview: IMAGEN,
          title: t('visor.image'),
          layers: [
            'TMS*Nombre*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*true*false*19*false',
          ],
        },
        {
          id: 'mapa',
          preview: MAPA,
          title: t('visor.street_map'),
          layers: [
            'WMTS*https://www.ign.es/wmts/ign-base*IGNBaseTodo*GoogleMapsCompatible*Callejero*false*image/jpeg*false*false*true',
          ],
        },
        {
          id: 'hibrido',
          title: t('visor.hybrid'),
          preview: HIBRIDO,
          layers: [
            'TMS*Nombre*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*true*false*19*false',
            'WMTS*https://www.ign.es/wmts/ign-base*IGNBaseOrto*GoogleMapsCompatible*Callejero*false*image/jpeg*false*false*true',
          ],
        },
      ],
    };
  } else {
    return {
      order: 10,
      position: 'TR',
      layerId: 0,
      layerVisibility: true,
      collapsed: true,
      collapsible: true,
      columnsNumber: 4,
      empty: true,
      layerOpts: [{
          id: 'raster',
          preview: RASTER,
          title: t('visor.map'),
          layers: [
            'WMTS*https://www.ign.es/wmts/mapa-raster*MTN*GoogleMapsCompatible*CartografíadelIGN*false*image/jpeg*false*false*true',
          ],
        },
        {
          id: 'imagen',
          preview: IMAGEN,
          title: t('visor.image'),
          layers: [
            'TMS*Nombre*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*true*false*19*false',
          ],
        },
        {
          id: 'mapa',
          preview: MAPA,
          title: t('visor.street_map'),
          layers: [
            'WMTS*https://www.ign.es/wmts/ign-base*IGNBaseTodo*GoogleMapsCompatible*Callejero*false*image/jpeg*false*false*true',
          ],
        },
        {
          id: 'hibrido',
          title: t('visor.hybrid'),
          preview: HIBRIDO,
          layers: [
            'TMS*Nombre*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*true*false*19*false',
            'WMTS*https://www.ign.es/wmts/ign-base*IGNBaseOrto*GoogleMapsCompatible*Callejero*false*image/jpeg*false*false*true',
          ],
        },
        {
          id: 'lidar',
          preview: LIDAR,
          title: t('visor.lidar'),
          layers: [
            'WMTS*https://wmts-mapa-lidar.idee.es/lidar*EL.GridCoverageDSM*GoogleMapsCompatible*LiDAR*false*image/png*false*false*true',
          ],
        },
        {
          id: 'ocupacion-suelo',
          preview: OCUPACION,
          title: t('visor.corine'),
          layers: [
            'WMTS*https://servicios.idee.es/wmts/ocupacion-suelo?*LC.LandCoverSurfaces*GoogleMapsCompatible*SIOSE*false*image/jpeg*false*false*true',
          ],
        },
        {
          id: 'historicos',
          preview: HISTORICOS,
          title: t('visor.historic'),
          layers: [
            'WMTS*https://www.ign.es/wmts/primera-edicion-mtn?*mtn50-edicion1*GoogleMapsCompatible*mtn50-edicion1*false*image/jpeg*false*false*true',
          ],
        },
      ],
    };
  }
};

const getConfiguredZoomSelectionPlugin = (t) => {
  return {
    position: 'TL',
    collapsible: true,
    collapsed: true,
    ids: 'peninsula,canarias,baleares,ceuta,melilla',
    titles: `${t('visor.peninsula')},${t('visor.canary')},${t('visor.balearic')},${t('visor.ceuta')},${t('visor.melilla')}`,
    previews: `${CONFIGURATIONS.api_url}/plugins/selectionzoom/images/espana.png,${CONFIGURATIONS.api_url}/plugins/selectionzoom/images/canarias.png,${CONFIGURATIONS.api_url}/plugins/selectionzoom/images/baleares.png,${CONFIGURATIONS.api_url}/plugins/selectionzoom/images/ceuta.png,${CONFIGURATIONS.api_url}/plugins/selectionzoom/images/melilla.png`,
    bboxs: '-1552619.0187665601, 716031.980737471, 4315935.001782093, 5419074.193993757, -2042698.4223479182, -1475535.6724719102, 3168647.129936522, 3444431.927989438 , 28352.127248126664, 595514.8771241345, 4645052.996617807, 4920837.794670723,-599755.2558583047, -587525.3313326766, 4281734.817081453, 4290267.100363785, -334717.4178261766, -322487.4933005484, 4199504.016876071, 4208036.300158403',
    zooms: '7,9,9,14,14',
    order: 2,
  };
};


